<template>
  <z-page class="division-view">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>搜索：</div>
        <div class="long">
          <el-input
            size="mini"
            v-model="search.text"
            placeholder="关键字搜索"
            suffix-icon="el-icon-search"
            class="long"
          >
            <el-select v-model="search.text_type" slot="prepend" placeholder="请选择">
              <el-option label="产品名称" :value="1"></el-option>
            </el-select>
            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
          </el-input>
        </div>
      </div>
      <div class="search-item">
        <div>时间：</div>
        <div class="long">
          <el-date-picker
            :picker-options="pickerOptions"
            class="datepicker long"
            v-model="search.start_time"
            size="mini"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM "
            placeholder="选择日期"
          ></el-date-picker>
        </div>
      </div>
      <div @click="searchData" class="search-btn z-btn normal">搜索</div>
      <div @click="claersearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
      <div @click="download" class="search-btn floatright">下载报表</div>
    </div>

    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>时间</div>
        <div>产品名称</div>
        <div>分成比例</div>
        <div>销售总额</div>
        <div>供应商所得</div>
        <div>海翕云所得</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div style="text-align: center" class="list-item" v-if="data_list.length<=0">暂无数据</div>
        <div v-for="(item, index) in data_list" :key="index" class="list-item">
          <div>{{item.statisticsMonth}}</div>
          <div>{{ item.productName }}</div>
          <div>{{ item.rate }}</div>
          <div>{{ item.allIncome |fix}}</div>
          <div>{{ item.supplierIncome||0 |fix}}</div>
          <div>{{ item.distributorIncome |fix}}</div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <z-pagination
      @sizeChange="getdata()"
      @pageChange="handleCurrentChange"
      :current-page.sync="now_page"
      :page-size="10"
      :total="total"
    ></z-pagination>
  </z-page>
</template>

<script>
export default {
  data() {
    return {
      // 限制时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      search: {
        //搜索框容器
        text: "",
        text_type: 1
      },
      now_page: 1,
      total: 0,
      searching: {
        //搜索时用的搜索值
      },
      loading: false,
      data_list: [] //数据容器
    };
  },
  created() {
    this.getdata();
  },
  methods: {
    //下载方法
    download() {
      this.$func.download(
        "api/supplier/eiisys/distribute/statistics/download",
        "海翕云分成统计"
      );
    },
    //搜索方法，  通过下拉框数据判断往搜索ING里传值
    searchData() {
      if (this.search.text_type == 1) {
        this.searching.product_name = this.search.text;
      } else {
        this.searching.distributor_name = this.search.text;
      }
      this.searching.start_time = this.search.start_time;
      this.handleCurrentChange(1);
    },
    //清除搜索条件并搜索
    claersearch() {
      this.searching = {};
      this.search = { text_type: 1 };
      this.handleCurrentChange(1);
    },
    // 页面改变
    handleCurrentChange(val) {
      this.nowpage = val;
      this.getdata();
    },
    //获取数据方法
    getdata(num) {
      this.loading = true;
      let url = `/api/supplier/eiisys/distribute/statistics`;
      this.$http
        .post(
          url,
          {},
          {
            params: {
              search_time: this.searching.start_time || null, // 时间
              page: num || this.now_page, // 页码
              product_name: this.searching.product_name || null //  产品名称
            }
          }
        )
        .then(res => {
          if (res.code == "200") {
            console.log(res);

            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.page-list {
  min-width: 300px;
}
.list-head,
.list-item {
  > div {
    width: 16%;
    &:nth-child(3) {
      width: 20%;
    }
  }
}
</style>
